<mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" class="px-15" fxLayoutAlign="space-between center">
        <span class="title dialog-title" [innerText]="data.titolo"></span>
        <button mat-icon-button (click)="onClose(null)" mat-dialog-close aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>
<mat-dialog-content class="content m-0 p-24" fxLayout="column">
    <div class="mat-subheading-2 mb-0" [innerHTML]="data.message"></div>

    <div [hidden]="!data.withPassword" class="mt-12">
        <form #passwordForm="ngForm">
            <mat-form-field style="margin-top: -20px" color="accent" appearance="standard">
                <input
                    matInput
                    type="password"
                    autocomplete="current-password"
                    placeholder="Password"
                    #passwordField="ngModel"
                    [(ngModel)]="password"
                    required />
            </mat-form-field>
        </form>
    </div>

    <mat-dialog-actions align="end">
        <button
            mat-raised-button
            [innerText]="data.cta"
            [disabled]="data.withPassword ? passwordField.invalid : false"
            (click)="onClose(true)"
            color="accent"></button>
        <button mat-raised-button *ngIf="data.showCtaAnnulla == true" [innerHTML]="data.buttonLabelAnnulla" (click)="onClose(false)" mat-dialog-close></button>
    </mat-dialog-actions>
</mat-dialog-content>
